import { makeStyles } from '@mui/styles'
import { isDarkColor } from '@v4/utils'
import { dark, light } from '@mui/material/styles/createPalette'

const useStyles = makeStyles(
	theme => ({
		wrapper: {
			position: 'relative',
			'&:hover': {
				'& $settingsButton': {
					opacity: 1,
					'& > span': {
						opacity: 1,
					},
				},
			},
		},
		visible: {
			opacity: '1 !important',
		},
		settingsButton: {
			opacity: 0,
			transition: theme.transitions.create(['opacity']),
			'& > span': {
				opacity: 0,
				transition: theme.transitions.create(['opacity']),
			},
		},
		topSettingsButton: {
			height: `calc(100% - ${theme.spacing(2)} + 4px)`,
			top: `calc(50% - ${theme.spacing(0.5)})`,
		},
		root: {
			margin: theme.spacing(0, -1),
			width: `calc(100% + ${theme.spacing(2)})`,

			'& $item': {
				padding: theme.spacing(1.25, 1),
			},
			'& $checkboxItem': {
				padding: theme.spacing(0, 1),
				width: '100%',
			},
		},
		item: {},
		checkboxItem: {},
		buttonProgress: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: -12,
			marginLeft: -12,
		},
		button: {
			height: 'auto',
			minHeight: theme.spacing(6),
			color: isDarkColor(theme.palette.primary.main) ? dark.text.primary : light.text.primary,
			borderRadius: ({ rounded }) => (rounded ? theme.spacing(4) : null),
		},
		buttonText: {
			textTransform: theme.typography.button.textTransform || 'none',
		},
		privacy: {
			width: '100%',
			textAlign: 'center',

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ mobileAlignment }) => mobileAlignment,
			},
		},
		link: {
			color: ({ usePaperColors }) => theme.palette.getTextColors(usePaperColors).secondary,
		},
		header: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: theme.spacing(-0.5),
			marginBottom: theme.spacing(1.25),
		},
		image: {
			width: '100%',
			height: '100%',
			maxWidth: theme.spacing(10),
			maxHeight: theme.spacing(10),
			marginRight: theme.spacing(1.25),
			overflow: 'hidden',

			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},
		titleWrap: {
			alignItems: 'center',
		},
		light: {
			// eslint-disable-next-line max-len
			'& input:-webkit-autofill,& input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
				WebkitBoxShadow: `0 0 0 5000px ${theme.palette.common.white} inset !important`,
				margin: 1,
				WebkitTextFillColor: light.text.primary,
			},
		},
		transparent: {
			// eslint-disable-next-line max-len
			'& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
				WebkitBoxShadow: ({ usePaperColors }) =>
					`0 0 0 5000px ${
						theme.palette.augmentColor({
							color: {
								main: theme.palette.background[usePaperColors ? 'paper' : 'default'],
							},
						}).light
					} inset !important`,
				margin: 1,
				borderRadius: 0,
				WebkitTextFillColor: ({ usePaperColors }) => theme.palette.getTextColors(usePaperColors).secondary,
			},
		},
		input: {},
		checkbox: {},
		select: {},
		title: {},
		hidden: {
			display: 'none !important',
		},

		buttonWrap: {},
		error: {
			textAlign: 'center',
			paddingTop: theme.spacing(1),
			position: 'static !important',
		},
	}),
	{ name: 'SignUpForm' },
)

export default useStyles
